<div *ngIf="Title" class="modal-header">
  <button bsMigration type="button" class="close pull-right" aria-label="Close" (click)="Close();"><span aria-hidden="true">&times;</span></button>
  <h4 class="modal-title">{{ Title }}</h4>
</div>
<div class="modal-body">
  <ng-container #popupContent></ng-container>
</div>
<div *ngIf="CloseText" class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="Close()">{{ CloseText }}</button>
</div>

<ng-template #stringTpl let-popup>
  <p [ngClass]="popup.ngClass">{{ popup.Message }}</p>
</ng-template>
